// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".react-slideshow-fade-wrapper {\n  width: 100%;\n  overflow: hidden;\n}\n\n.react-slideshow-fade-wrapper .react-slideshow-fade-images-wrap {\n  display: flex;\n  flex-wrap: wrap;\n}\n\n.react-slideshow-fade-wrapper .react-slideshow-fade-images-wrap > div {\n  position: relative;\n  opacity: 0;\n}\n", ""]);
// Exports
module.exports = exports;
